/**************************************************
 * Nombre:
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid2, Typography} from "@mui/material";
import Tarjeta_Caracteristicas_Home from "../Tarjetas/Tarjeta_Caracteristicas_Home";
import ic_ingreso from '../../../../Recursos/ic_ingreso.svg'
import ic_periodico from '../../../../Recursos/ic_periodico.svg'
import ic_retiro from '../../../../Recursos/ic_retiro.svg'
import ic_incapacidad from '../../../../Recursos/ic_incapacidad.svg'


const Lista_Tarjeta_Caracteristicas_Home = () => {

    return (
        <Grid2
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={12}
            spacing={0}>

            <Grid2 container size={{xs: 12, sm: 12, md: 11}} justifyContent={'center'} >
                <Typography sx={{fontSize: 18, fontWeight: 400}}>Conoce a que nos dedicamos</Typography>
            </Grid2>

            <Grid2 container size={{xs: 12, sm: 12, md: 11}} justifyContent={'center'} sx={{mt: -1}}>
                <Typography sx={{fontSize: 32, fontWeight: 800,textAlign: 'center'}}>Nuestros Programas Principales</Typography>
            </Grid2>



            <Grid2 container
                   size={12}
                   spacing={8}
                   sx={{mt: 6}}
            >

            {caracteristicas.map((caracteristica, index) => (

                <Grid2 container size={{xs: 12, sm: 6, md: 6}}>
                    <Tarjeta_Caracteristicas_Home
                        titulo={caracteristica.titulo}
                        parrafo={caracteristica.parrafo}
                        icono={caracteristica.icono}
                    />
                </Grid2>
            ))}

            </Grid2>

        </Grid2>
    )

}
export default Lista_Tarjeta_Caracteristicas_Home

const caracteristicas = [
    {
        icono: ic_ingreso,
        titulo: 'Corazón Solidario:',
        parrafo: 'Brinda apoyo económico (bonos alimentarios, educativos y transporte) y actividades de fortalecimiento de habilidades para personas con discapacidad de familias con escasos recurso'
    },
    {
        icono: ic_periodico,
        titulo: 'Aguja Dorada',
        parrafo: 'Programa de emprendimiento dirigido a las familias de los beneficiarios para que desarrollen competencias en áreas como administración y liderazgo a través de iniciativas productivas (como artesanías y bordados).'
    },
    {
        icono: ic_retiro,
        titulo: 'Apoyo Terapéutico y Pedagógico',
        parrafo: 'Ofrece intervenciones especializadas en fonoaudiología, psicología, terapia ocupacional y educación especial para mejorar habilidades lingüísticas, motrices y cognitivas.'
    },
    {
        icono: ic_incapacidad,
        titulo: 'Proyección Social (Formación y Capacitación)',
        parrafo: 'Realizan talleres y asesorías a entidades públicas y privadas sobre temas como discapacidad, políticas de educación inclusiva y flexibilización curricular.'
    }
]